var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"card-c",attrs:{"title":"历史人数演变"}},[_c('div',{ref:"c1",staticClass:"c-s"})])
}
var staticRenderFns = []

export { render, staticRenderFns }